import { useSelectForms } from "@/features/forms/api/selectForms";
import { useScheduleByIdQuery } from "@/features/schedules/api/selectSchedulesById";
import type { TemplateT } from "@/types/database/quickstarts";
import { Hospital } from "lucide-react";
import { Badge } from "../../../components/ui/badge";

type Template = TemplateT & {
  templates_access: {
    access: "viewer" | "editor";
  }[];
};

function TrackersInfo({ template }: { template: Template }) {
  const settings = template.settings;
  const { data: forms } = useSelectForms();
  const scheduleId = settings?.trackers?.[0]?.schedule_id;
  const { data: schedule } = useScheduleByIdQuery(scheduleId);

  // Helper: Get grouped tracker info
  function getTrackerGroups() {
    return (settings.trackers || []).map(
      (tracker: { form_id: string; schedule_id: string }, idx: number) => {
        const form = forms?.find((f) => f.form_id === tracker.form_id);
        const scheduleForTracker = scheduleId === tracker.schedule_id
          ? schedule
          : undefined;
        return { form, schedule: scheduleForTracker, tracker };
      },
    );
  }

  return (
    <div className="flex flex-col gap-0">
      {/* Organisation at the top, most prominent */}
      {settings.organisation_name && (
        <div className="flex items-center gap-2 mb-4">
          <Hospital className="w-6 h-6 text-indigo-600" />
          <span className="font-bold text-indigo-900 dark:text-indigo-200 text-lg">
            {settings.organisation_name}
          </span>
        </div>
      )}
      {/* Forms and Schedules grouped, with visual hierarchy */}
      <div className="flex flex-wrap gap-2">
        {getTrackerGroups().map(({ form, tracker }, idx) => (
          tracker?.form_id && form?.form_name && (
            <Badge variant="outline" key={tracker?.form_id || idx}>
              {form.form_name}
            </Badge>
          )
        ))}
      </div>
    </div>
  );
}

export default TrackersInfo;
